import type { TaskDueFilter } from '@src/features/tasks/types';
import { SidePanelContent } from '@src/shared/ui/SidePanel';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TasksFilter from './TasksFilter';
import TasksList from './TasksList';

export type TasksProps = {
  /**
   * Section whose tasks to show, e.g. "absence" -- the same name the reference
   * resolvers are registered under. Omitted, the panel reaches every open task
   * the viewer can reach, which is what the landing and dashboard pages want,
   * and offers the overdue/upcoming filter to cut that down. Scoped to a
   * section the list is already short, so there is nothing there to narrow.
   */
  referenceType?: string;
};

export default function Tasks({ referenceType }: TasksProps) {
  const { t } = useTranslation();
  const [dueFilter, setDueFilter] = useState<TaskDueFilter>('overdue');
  const showFilter = !referenceType;

  return (
    <SidePanelContent
      title={t('common.tasks', 'Tasks')}
      headerContent={
        showFilter ? (
          <TasksFilter value={dueFilter} onChange={setDueFilter} />
        ) : undefined
      }
    >
      <TasksList
        referenceType={referenceType}
        dueFilter={showFilter ? dueFilter : undefined}
      />
    </SidePanelContent>
  );
}
